import React from "react";
import styles from "./card.module.scss";
import { getImage } from "../../../../utils/Misc/get-image";
import { Button, Tooltip } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

export const RateContractProductCard = ({
  product,
  userType,
  mdView,
  onClick = () => {},
  added: addedArr = [],
  onAdd = () => {},
}) => {
  const price = React.useMemo(() => {
    if (!mdView) {
      return product?.md_price_gst;
    }
    if (userType === "studio" || mdView) return product?.md_price_gst_studio;
    if (userType === "enterprise") return product?.md_price_gst_msp;
  }, [
    mdView,
    product?.md_price_gst,
    product?.md_price_gst_msp,
    product?.md_price_gst_studio,
    userType,
  ]);

  const landingPrice = React.useMemo(() => {
    if (!mdView) {
      return product?.md_landing_price_gst;
    }
    if (userType === "studio" || mdView)
      return product?.md_landing_price_gst_studio;
    if (userType === "enterprise") return product?.md_landing_price_gst_msp;
  }, [
    mdView,
    product?.md_landing_price_gst,
    product?.md_landing_price_gst_msp,
    product?.md_landing_price_gst_studio,
    userType,
  ]);

  const added = React.useMemo(() => {
    return addedArr.includes(product?.product_name);
  }, [addedArr, product?.product_name]);

  return (
    <div
      className={styles.card}
      onClick={(event) => {
        onClick(product);
      }}
    >
      <img
        src={getImage(
          "product-tile",
          "tile-image",
          product.variant_image[0]?.image
            ? product.variant_image[0]?.image
            : product.variant_image[0]?.image_url
        )}
        alt={product?.product_name}
        className={styles.image}
      />
      <div className={styles.details}>
        <section className={styles.text}>
          <div className={styles.brandName}>{product?.brand?.brand_name}</div>
          <div className={styles.productName}>
            <Tooltip title={product?.product_name}>
              {product.product_name.length > 40
                ? `${product.product_name.slice(
                    0,
                    24
                  )}... ${product.product_name.slice(-10)}`
                : product.product_name}
            </Tooltip>
          </div>
        </section>
        <section className={styles.actions}>
          <Button
            shape="circle"
            type="primary"
            className={`${styles.button} ${added && styles.added}`}
            icon={added ? <MinusOutlined /> : <PlusOutlined />}
            onClick={(event) => {
              event.stopPropagation();
              onAdd(product);
            }}
            size="medium"
          />
        </section>
      </div>
      {product.md_price_gst &&
        product.mrp &&
        product.md_price_gst?.toString() !== "" && (
          <div className={styles.priceContainer}>
            <div className={styles.price}>
              <div>
                ₹{price}
                {""}
                <span className={styles.priceUnitContainer}>
                  {product?.price_unit && "/"}
                  {product?.price_unit ?? ""}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                {/* <div
                  style={{
                    display: "flex",
                    fontSize: "75%",
                    color: "#bababa",
                  }}
                >
                  MRP <span className={styles.mrpPrice}>₹{product.mrp}</span>
                </div> */}
                {landingPrice && (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "75%",
                      color: "#535353",
                    }}
                  >
                    <span>
                      ₹{landingPrice}/{product.md_landing_price_unit}
                    </span>
                  </div>
                )}
              </div>
              {/* <p className={styles.mrpPrice}> */}
              {/*   MRP ₹{product.mrp} */}
              {/* </p> */}
            </div>
            {/* <div */}
            {/*   className={ */}
            {/*     addedToCart ? styles.cartIconHighlighted : styles.cartIcon */}
            {/*   } */}
            {/* > */}
            {/*   <AddShoppingCartIcon onClick={addToCart} /> */}
            {/* </div> */}
          </div>
        )}
    </div>
  );
};
